import {
  GroupedNotesModel,
  GroupedLessonModel,
  GroupedVideoModel,
} from '@/models/student-notes/note.model';

export const filterGroupedNotes = (
  groupedNotebookNotes: GroupedNotesModel[],
  disciplineSelected: string,
  lessonSelected: string,
  videoSelected: string,
) => {
  const findDisciplineByName = (discipline: GroupedNotesModel) =>
    discipline.discipline === disciplineSelected;

  const findDisciplineWithLesson = (discipline: GroupedNotesModel) =>
    discipline.discipline === disciplineSelected &&
    discipline.lessons.some((lesson) => lesson.lesson === lessonSelected);

  const findDisciplineFunction =
    disciplineSelected && !lessonSelected ? findDisciplineByName : findDisciplineWithLesson;

  const discipline = groupedNotebookNotes.find(findDisciplineFunction);

  if (!discipline) {
    return [];
  }

  if (disciplineSelected && !lessonSelected) {
    return discipline.lessons.reduce((acc: any, lesson: GroupedLessonModel) => {
      return [...acc, ...lesson.videos];
    }, []);
  }

  const videos = discipline.lessons
    .filter((lesson: GroupedLessonModel) => lesson.lesson === lessonSelected)
    .reduce((acc: GroupedVideoModel[], lesson: GroupedLessonModel) => {
      return [...acc, ...lesson.videos];
    }, []);

  return videoSelected
    ? videos.filter((video: GroupedVideoModel) => video.video === videoSelected)
    : videos;
};
